import { useRouter } from "next/router";
import { GoogleReCaptchaProvider,  useGoogleReCaptcha } from "react-google-recaptcha-v3";
import React, { useEffect, useState,useCallback } from "react";
import { Spinner } from "react-bootstrap";
import { webServiceClient } from "../../data/apiClient";
import useTrait from "../Common/syncUpdateState";
import * as ga from "../../lib/ga";
import { set } from "react-hook-form";

const VehicleSearchTabComponent = (props) => {
  const { title, tab } = props;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const router = useRouter();
  const [isLoaded, SetLoaded] = React.useState(false);
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const apiService = webServiceClient(SetLoaded);
  const [fromSubmit, SetFromSubmit] = React.useState(false);
  const isProduction = process.env.NODE_ENV === "production";
  const [recaptchaResponse, setRecaptchaResponse]=React.useState();
const recaptchaReload= useTrait(false);
const [twoLengthResponse, setTwoLengthResponse]=useState({isLoad:false, value:"", methodName:""});


  var SearchModels = useTrait({
    makes: [],
    models: [],
    years: [],
    series: [],
    engines: [],
    details: [],
    vehicleDetails: [],
  });

  var data = useTrait({
    make: "",
    model: "",
    year: "",
    series: "",
    engine: "",
    detail: "",
    vehicleId: 0,
  });

  var pa = tab == 0;
  var hc = tab == 2;
  var mc = tab == 1;
  var lc = tab == 3;
  var ma = tab == 4;

  var [modelList, setModelList] = useState();
 
  // useEffect(()=>{
  //   if(recaptchaResponse && !twoLengthResponse.isLoad && twoLengthResponse.methodName==="getAutoDetails"){
  //     //console.log("2nd call...")
  //           getAutoDetails(twoLengthResponse.value);
  //           setTwoLengthResponse({isLoad:false, value:"", methodName:""})
  //         }
     

  // }, [recaptchaResponse,twoLengthResponse,getAutoDetails])

  // // You can use useEffect to trigger the verification as soon as the component being loaded
  // useEffect(() => {
  //   // debugger
  //   if(recaptchaReload.get()){
  //     handleReCaptchaVerify();
  //     recaptchaReload.set(false);
      
  //     //setIsLengthTwo(false);
  //   }
    
   
  // }, [handleReCaptchaVerify,recaptchaReload,twoLengthResponse,getAutoDetails]);

  // useEffect(() => {
  //   // debugger
  //   if(twoLengthResponse.isLoad){
  //    // console.log("first call...")
  //     handleReCaptchaVerify();
  //     recaptchaReload.set(true);
  //     setTwoLengthResponse({...twoLengthResponse, isLoad:false})
  //   }
  //   // else{
  //   //   if(twoLengthResponse.methodName==="getAutoDetails"){
  //   //     console.log("2nd call...")
  //   //           getAutoDetails(twoLengthResponse.value);
  //   //           setTwoLengthResponse({isLoad:false, value:"", methodName:""})
  //   //         }
  //   //    }
   
  // }, [handleReCaptchaVerify,twoLengthResponse,recaptchaReload]);
  useEffect(() => {
    getListItem(
      {
        ReturnField: "Make",
        PA: pa,
        HC: hc,
        MC: mc,
        LC: lc,
        MA: ma,
      },
      "make"
    );
    data.set({
      make: "",
      model: "",
      year: "",
      series: "",
      engine: "",
      detail: "",
      vehicleId: 0,
    });
    SearchModels.set({
      makes: [],
      models: [],
      years: [],
      series: [],
      engines: [],
      details: [],
      vehicleDetails: [],
    });
  }, [title, pa, hc, mc, lc, ma]);

  var getListFromApi= async (param)=>{
   // debugger;
    if(recaptchaResponse)
    setRecaptchaResponse("");
  else
  recaptchaReload.set(true);
//debugger;
    return await apiService.getPartsList(param);
  }

  var getListItem = async (param, type) => {
    
    param={...param}
    try {
      const resp = await  getListFromApi(param);
      var currentSearchModel = SearchModels.get();
      if (type === "make") {
        SearchModels.set({
          ...currentSearchModel,
          makes: resp?.data?.options,
          models: [],
          years: [],
          series: [],
          engines: [],
          details: [],
        });
      } else if (type === "model") {
        SearchModels.set({
          ...currentSearchModel,
          models: resp?.data?.options,
          years: [],
          series: [],
          engines: [],
          details: [],
        });
      } else if (type === "year") {
        const result = resp?.data?.options || [];
        SearchModels.set({
          ...currentSearchModel,
          years: result,
          series: [],
          engines: [],
          details: [],
        });
      } else if (type === "series") {
        const result = resp?.data?.options || [];
        SearchModels.set({
          ...currentSearchModel,
          series: result,
          engines: [],
          details: [],
        });
      } else if (type === "engine") {
        const result = resp?.data?.options || [];
        SearchModels.set({
          ...currentSearchModel,
          engines: result,
          details: [],
        });
        //await isLengthTwo.set(true);
        //if engines list length 2,
        //then update the setData
        //then update the
        if (result.length == 2) {
          // debugger
          //isLengthTwo.set(true);
             
          var currentData = data.get();
          var updateData = {
            ...currentData,
            engine: result[1],
            detail: "",
            vehicleId: 0,
          };
          data.set(updateData);
          //setTwoLengthResponse({...twoLengthResponse,isLoad:true, value:updateData.engine, methodName:"getAutoDetails"});
          getAutoDetails(updateData.engine);
        }
      } else if (type === "details") {
        const result = resp?.data?.options || [];
        SearchModels.set({
          ...currentSearchModel,
          details: result,
          vehicleDetails: resp?.data,
        });
        if (result.length == 2) {
     
          var currentData = data.get();
          var updateData = {
            ...currentData,
            detail: result[1],
            vehicleId: 0,
          };
          data.set(updateData);
          getAutoVehicleId(updateData.engine);
        }
      }
      recaptchaReload.set(true);
    } catch (err) {
      // console.log(err);
      // showAlert("Unexpected error occurgray doing search");
    }
  };

  var getMakeModel =async function (event, autoSearch = false) {
    var currentData = {
      make: event.target.value,
      model: "",
      year: "",
      series: "",
      engine: "",
      detail: "",
      vehicleId: 0,
    };
    const Token=await executeRecaptcha("regoSearch");

   await data.set(currentData);
    getListItem(
      {
        ReturnField: "Model",
        PA: pa,
        HC: hc,
        MC: mc,
        LC: lc,
        MA: ma,
        Make: currentData.make,
        Token:Token
      },
      "model"
    );
  };

  var getYear =async function (event, autoSearch = false) {
    var currentData = data.get();
    var updateData = {
      make: currentData.make,
      model: event.target.value,
      year: "",
      series: "",
      engine: "",
      detail: "",
      vehicleId: 0,
    };
    await data.set(updateData);
    const Token=await executeRecaptcha("regoSearch");
    getListItem(
      {
        ReturnField: "year",
        PA: pa,
        HC: hc,
        MC: mc,
        LC: lc,
        MA: ma,
        Make: updateData.make,
        Model: updateData.model,
        Token:Token
      },
      "year"
    );
  };

  var getSeries = async function (event, autoSearch = false) {
    var currentData = data.get();
    var updateData = {
      make: currentData.make,
      model: currentData.model,
      year: event.target.value,
      series: "",
      engine: "",
      detail: "",
      vehicleId: 0,
    };
   await data.set(updateData);
   const Token=await executeRecaptcha("regoSearch");
    getListItem(
      {
        ReturnField: "Series",
        PA: pa,
        HC: hc,
        MC: mc,
        LC: lc,
        MA: ma,
        Make: updateData.make,
        Model: updateData.model,
        Year: updateData.year,
        Token:Token
      },
      "series"
    );
  };

  var getEngines = async function (event, autoSearch = false) {
    var currentData = data.get();
    var updateData = {
      make: currentData.make,
      model: currentData.model,
      year: currentData.year,
      series: event.target.value,
      engine: "",
      detail: "",
      vehicleId: 0,
    };
    await data.set(updateData);
    const Token=await executeRecaptcha("regoSearch");
    getListItem(
      {
        ReturnField: "Engine",
        PA: pa,
        HC: hc,
        MC: mc,
        LC: lc,
        MA: ma,
        Make: updateData.make,
        Model: updateData.model,
        Year: updateData.year,
        Series: updateData.series,
        Token:Token
      },
      "engine"
    );
  };

  var getDetails =async function (event, autoSearch = false) {
    var currentData = data.get();
    var updateData = {
      make: currentData.make,
      model: currentData.model,
      year: currentData.year,
      series: currentData.series,
      engine: event.target.value,
      detail: "",
      vehicleId: 0,
    };
    await data.set(updateData);
    const Token=await executeRecaptcha("regoSearch");
    getListItem(
      {
        ReturnField: "Details",
        PA: pa,
        HC: hc,
        MC: mc,
        LC: lc,
        MA: ma,
        Make: updateData.make,
        Model: updateData.model,
        Year: updateData.year,
        Series: updateData.series,
        Engine: updateData.engine,
        Token:Token
      },
      "details"
    );
  };

  var getAutoDetails =async function (engineValue) {
    //console.log("end task start...")
    var currentData = data.get();
    var updateData = {
      make: currentData.make,
      model: currentData.model,
      year: currentData.year,
      series: currentData.series,
      engine: engineValue,
      detail: "",
      vehicleId: 0,
    };
    data.set(updateData);
    const Token=await executeRecaptcha("regoSearch");
   // debugger;
    getListItem(
      {
        ReturnField: "Details",
        PA: pa,
        HC: hc,
        MC: mc,
        LC: lc,
        MA: ma,
        Make: updateData.make,
        Model: updateData.model,
        Year: updateData.year,
        Series: updateData.series,
        Engine: updateData.engine,
        Token:Token
      },
      "details"
    );
  };

  var getVehicleId = function (event) {
    var currentData = data.get();
    var currentSearchModel = SearchModels.get();
    var length = currentSearchModel?.vehicleDetails?.details.length;
    for (var i = 0; i < length; i++) {
      if (
        currentSearchModel?.vehicleDetails?.details[i].option ==
        event.target.value
      ) {
        currentData.detail = event.target.value;
        currentData.vehicleId =
          currentSearchModel?.vehicleDetails?.details[i].vehicleIdEncrypted;
        data.set(currentData);
        SetFromSubmit(true);
        break;
      }
    }
  };

  var getAutoVehicleId =async function (detailValue) {
   // await  isLengthTwo.set(true);
   
    var currentData = data.get();
    var currentSearchModel = SearchModels.get();
    var length = currentSearchModel?.vehicleDetails?.details.length;
    for (var i = 0; i < length; i++) {
      if (
        currentSearchModel?.vehicleDetails?.details[i].option == detailValue
      ) {
        currentData.detail = detailValue;
        currentData.vehicleId =
          currentSearchModel?.vehicleDetails?.details[i].vehicleId;
        data.set(currentData);
        SetFromSubmit(true);
        break;
      }
    }
  };

  const submitForm = async (event) => {
    event.preventDefault();
    SetFromSubmit(false);
    var SearchType= title.split("-")[1];
    if (isProduction) {
      ga.event({
        action: data.get()?.vehicleId,
        params: {
          event_category: SearchType,
        },
      });
      //console.log("search Type", SearchType);
    }
   
    router.push("/results/" + data.get()?.vehicleId);
  };

  return (
    <>
      <div className='py-3 py-lg-5'>
        <div className='container'>
          <h4 className='d-md-block d-none'>
            <strong>
              {title}{" "}
              {isLoaded && (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </strong>
            <small className='d-flex fw-normal'>
              Select your vehicle details from the drop down
            </small>
          </h4>
          <div className='row g-2'>
            <div className='col-sm-4'>
              <div className='form-group'>
                <label htmlFor='make'>MAKE</label>
                <select
                  style={{
                    borderLeft:
                      SearchModels.get()?.makes?.length > 0
                        ? "4px solid green"
                        : "4px solid red",
                  }}
                  disabled={!SearchModels.get()?.makes?.length}
                  className='form-select'
                  id='make'
                  aria-label='Popular Make'
                  value={data.get().make}
                  onChange={getMakeModel}
                >
                  <option value='' disabled>- Popular Makes -</option>
                  {SearchModels.get()?.makes?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='form-group'>
                <label htmlFor='model'>MODEL</label>
                <select
                  style={{
                    borderLeft:
                      SearchModels.get()?.models.length > 0
                        ? "4px solid green"
                        : "4px solid red",
                  }}
                  disabled={!SearchModels.get()?.models.length}
                  className='form-select'
                  id='model'
                  aria-label='Popular Model'
                  value={data.get().model}
                  onChange={getYear}
                >
                  <option value='' disabled>- Select Model -</option>
                  {SearchModels.get()?.models?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='form-group'>
                <label htmlFor='year'>YEAR</label>
                <select
                  style={{
                    borderLeft:
                      SearchModels.get()?.years.length > 0
                        ? "4px solid green"
                        : "4px solid red",
                  }}
                  disabled={!SearchModels.get()?.years.length}
                  className='form-select'
                  id='year'
                  aria-label='Floating label select example'
                  value={data.get().year}
                  onChange={getSeries}
                >
                  <option value='' disabled>- Select Year -</option>
                  {SearchModels.get()?.years?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='form-group'>
                <label htmlFor='series'>SERIES</label>
                <select
                  style={{
                    borderLeft:
                      SearchModels.get()?.series.length > 0
                        ? "4px solid green"
                        : "4px solid red",
                  }}
                  disabled={!SearchModels.get()?.series.length}
                  className='form-select'
                  id='series'
                  aria-label='Floating label select example'
                  value={data.get().series}
                  onChange={getEngines}
                >
                  <option value='' disabled>- Select Series -</option>
                  {SearchModels.get()?.series?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='form-group'>
                <label htmlFor='engine'>ENGINE</label>
                <select
                  style={{
                    borderLeft:
                      SearchModels.get()?.engines.length > 0
                        ? "4px solid green"
                        : "4px solid red",
                  }}
                  disabled={!SearchModels.get()?.engines.length}
                  className='form-select'
                  id='engine'
                  aria-label='Floating label select example'
                  value={data.get().engine}
                  onChange={getDetails}
                >
                  <option value='' disabled>- Select Engine -</option>
                  {SearchModels.get()?.engines?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='form-group'>
                <label htmlFor='vehicle'>VEHICLE</label>
                <select
                  style={{
                    borderLeft:
                      SearchModels.get()?.details.length > 0
                        ? "4px solid green"
                        : "4px solid red",
                  }}
                  disabled={!SearchModels.get()?.details.length}
                  className='form-select'
                  id='vehicle'
                  aria-label='Floating label select example'
                  value={data.get().detail ?? ''}
                  onChange={getVehicleId}
                >
                  <option value='' disabled>- Select Vehicle -</option>
                  {SearchModels.get()?.details?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-sm-12 col-lg-2 align-items-end d-flex'>
              <div className='form-group w-100'>
                <button
                  type='button'
                  style={{
                    backgroundColor: !fromSubmit ? "#ff0000" : "#ed1b2f",
                    color: !fromSubmit ? "black" : "white",
                  }}
                  className='btn btn-primary w-100'
                  onClick={submitForm}
                  disabled={!fromSubmit}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VehicleSearchTabComponent;
